module.exports = __webpack_public_path__ + "static/media/props.3f146e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/state-of-styling/assets/props.png
// module id = 382
// module chunks = 0